import { applyMiddleware } from 'redux';
import { createLogger } from 'redux-logger';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import { AuthMiddleware } from './middlewares/AuthMiddleware';
import { PromiseMiddleware } from './middlewares/PromiseMiddleware';
import { ListenerMiddleware } from './middlewares/ListenerMiddleware';
import { EnvironemtTypes, EnvironmentVariables } from '../constants/EnvironmentVariables';

const _getMiddleware = () => {
  switch (EnvironmentVariables.EnvironmentType) {
    case EnvironemtTypes.PROD:
      return applyMiddleware(AuthMiddleware, PromiseMiddleware, ListenerMiddleware);
    case EnvironemtTypes.DEV:
      return applyMiddleware(AuthMiddleware, PromiseMiddleware, ListenerMiddleware, createLogger());
    default:
      return applyMiddleware(AuthMiddleware, PromiseMiddleware, ListenerMiddleware, createLogger());
  }
};

export const getMiddleware = () => {
  switch (EnvironmentVariables.EnvironmentType) {
    case EnvironemtTypes.PROD:
      return _getMiddleware();
    case EnvironemtTypes.DEV:
      return composeWithDevTools(_getMiddleware());
    default:
      return composeWithDevTools(_getMiddleware());
  }
};
